/* eslint-disable */
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

momentDurationFormatSetup(moment)
export default {
  methods: {
    exists(field, items, value, except) {
      let response = true
      items = (items === null) ? this.items : items
      items.map(function (currentValue) {
        if (value === currentValue[field]) {
          response = false
        }
      }, this)
      except = (except === null)
        ? [this.beforeEditedItem[field]] || [] : except
      if (except.includes(value)) {
        response = true
      }

      return response
    },
    exist(field, items, value, except) {
      let response = true
      items = (items === null) ? this.items : items
      items.map(function (currentValue) {
        if (value === currentValue[field]) {
          response = false
        }
      }, this)
      except = (except === null)
        ? [this.beforeEditedItem[field]] || [] : except
      except.map(function (currentValue) {
        if (value.includes(currentValue)) {
          response = true
        }
      }, this)
      return response
    },
    dateCompare(begin, end) {
      return parseInt(moment(end).diff(moment(begin))) >= 0
    },
    emailMany(value) {
      let response = true
      value.forEach((val) => {
        if (/.+@.+/.test(val) === false) {
          response = false
        }
      })
      return response
    },
    existsMany(field, items, value, except) {
      let response = true

      // Caso os itens não sejam informados no componente é pego o This.Items
      items = (items === null) ? this.items : items
      items.map(function (currentValue) {
        if (value.includes(currentValue[field])) {
          response = false
        }
      }, this)
      // caso não seja informado os valores para exceção, será buscado o valor do campo da edição sem ser alterado
      except = (except === null)
        ? [this.beforeEditedItem[field]] || [] : except
      // Caso algum dos valores do campo seja encontrado nos valores de exceção, ele não será considerado colocando a resposta como true
      except.map(function (currentValue) {
        if (value.includes(currentValue)) {
          response = true
        }
      }, this)
      return response
    },
    existsManyUser(field, items, value, except) {
      let response = true
      items = (items === null) ? this.items : items
      items.map(function (currentValue) {
        if (value.includes(currentValue.user ? currentValue['user'][field] : currentValue[field])) {
          response = false
        }
      }, this)
      except = (except === null)
        ? [this.beforeEditedItem[field]] || [] : except
      except.map(function (currentValue) {
        if (value.includes(currentValue)) {
          response = true
        }
      }, this)
      return response
    },
    error(errorMessage) {
      return errorMessage
    },
    // type 0 = Telefone/Celular 1 = Celular 2 = Fixo
    phone(value, type) {
      if (type === 0) {
        return (/^(?:(55\d{2})|\d{2})([6-9]\d{8}|\d{8})$/g.test(value) || /^(?:(55\d{2})|\d{2})\d{8}$/g.test(value) ||
        'Telefone inválido (EX: (xx)9xxxx-xxxx )')
      } else if (type === 1) {
        return (/^(?:(55\d{2})|\d{2})([6-9]\d{8}|\d{8})$/g.test(value) ||
        'Telefone Celular inválido (EX: (xx)9xxxx-xxxx )')
      } else {
        return (/^(?:(55\d{2})|\d{2})\d{8}$/g.test(value) ||
        'Telefone Fixo inválido (EX: (xx)xxxx-xxxx )')
      }
    },
    validCpf: function(cpf) {
      if ( !cpf || cpf.length != 11
        || cpf == "00000000000"
        || cpf == "11111111111"
        || cpf == "22222222222" 
        || cpf == "33333333333" 
        || cpf == "44444444444" 
        || cpf == "55555555555" 
        || cpf == "66666666666"
        || cpf == "77777777777"
        || cpf == "88888888888" 
        || cpf == "99999999999" )
      return false
    var soma = 0
      var resto
    for (var i = 1; i <= 9; i++) 
      soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
    resto = (soma * 10) % 11
      if ((resto == 10) || (resto == 11))  resto = 0
      if (resto != parseInt(cpf.substring(9, 10)) ) return false
    soma = 0
      for (var i = 1; i <= 10; i++) 
        soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i)
      resto = (soma * 10) % 11
      if ((resto == 10) || (resto == 11))  resto = 0
      if (resto != parseInt(cpf.substring(10, 11) ) ) return false
      return true
    },
    validCnpj: function(cnpj) {
      if ( !cnpj || cnpj.length != 14
          || cnpj == "00000000000000" 
          || cnpj == "11111111111111" 
          || cnpj == "22222222222222" 
          || cnpj == "33333333333333" 
          || cnpj == "44444444444444" 
          || cnpj == "55555555555555" 
          || cnpj == "66666666666666" 
          || cnpj == "77777777777777" 
          || cnpj == "88888888888888" 
          || cnpj == "99999999999999")
          return false
      var tamanho = cnpj.length - 2
      var numeros = cnpj.substring(0,tamanho)
      var digitos = cnpj.substring(tamanho)
      var soma = 0
      var pos = tamanho - 7
      for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
      if (resultado != digitos.charAt(0)) return false;
      tamanho = tamanho + 1
      numeros = cnpj.substring(0,tamanho)
      soma = 0
      pos = tamanho - 7
      for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
      if (resultado != digitos.charAt(1)) return false
       return true;
    },
    error(errorMessage) {
      return errorMessage
    },
    // -------- Funciona sem as regras direto no banco ----------------------
    existIllisDBRule (field, index, entity = this.entity) {
      if ((this.editedItem[field] !== '') && (this.editedItem[field] !== (this.beforeEditedItem ? this.beforeEditedItem[field] : ''))) {
        this.field_errors[index].loading = true
        this.field_errors[index].text = ''
        this.$http.get(`api/exist_db_rule/${entity}/${field}/${this.editedItem[field]}`).then(
          (res) => {
            this.field_errors[index].loading = false
            if (!res.body) {
              this.field_errors[index].text = ''
              return true
            } else {
              this.field_errors[index].text = `${this.translate(`table.${entity}.field.${field}`)} já existe. Favor usar outro!`
              return false
            }
          })
      }
    },
    hasDBRule() {
      let someErro = this.field_errors.some((value, index, array) => {
        return value.text !== ''
      })
      if (someErro) {
        this.$store.commit('snackbar/change_values', {
          text: 'Por favor, corrija as validações antes de salvar!',
          color: 'warning',
          dialog: true
        })
        return true
      }
      let someLoading = this.field_errors.some((value, index, array) => {
        return value.loading
      })
      if (someLoading) {
        this.$store.commit('snackbar/change_values', {
          text: `Aguarde finalizar a verificação dos campos e tente novamente!`,
          color: 'warning',
          dialog: true
        })
        return true
      }
    }
    // -------- Funciona sem as regras direto no banco ----------------------
  },
  computed: {
    existRule: function () {
      return function (label, field, required = true, items = null, except = null) {
        return [
          required ? value => !!value ||
            this.error('O campo "' + label + '" é obrigatório') : true,
          value => value ? this.exists(field, items, value, except) ||
            'O registro já foi incluído' : true
        ]
      }
    },
    existManyRule: function () {
      return function (
        label, field, required = true, items = null, except = null) {
        return [
          required ? value => (value.length > 0) ||
            this.error('O campo "' + label + '" é obrigatório') : true,
          value => value ? this.existsMany(field, items, value, except) ||
            'O registro já foi incluído' : true
        ]
      }
    },
    trueRule: function () {
      return [
        true
      ]
    },
    emailRule: function () {
      return function (
        label, exist = false, required = true, field = null, items = null) {
        return [
          required ? value => !!value || 'O campo "' + label + '" é obrigatório' : true,
          value => value ? /.+@.+/.test(value) || 'O E-mail deve ser válido' : true,
          exist ? value => value ? this.exists(field ? field : 'email', items, value, null) || 'Esse email já foi incluído' : true : true
        ]
      }
    },
    cpfRule: function () {
      return function (
        label = 'CPF*', required = true) {
        return [
          required ? value => !!value || 'O campo "' + label + '" é obrigatório' : true,
          value => value ? this.validCpf(value) || 'O CPF deve ser válido' : true,
        ]
      }
    },
    cnpjRule: function () {
      return function (
        label = 'CNPJ*', required = true) {
        return [
          required ? value => !!value || 'O campo "' + label + '" é obrigatório' : true,
          value => value ? this.validCnpj(value) || 'O CNPJ deve ser válido' : true,
        ]
      }
    },
    emailManyRule: function () {
      return function (
        label, exist = false, required = true, field = null, items = null) {
        return [
          required ? value => (value.length > 0) || this.error('O campo ' + label + ' é obrigatorio ') : true,
          value => value ? this.emailMany(value) || 'O E-mail deve ser valido' : true,
          exist ? value => this.existsManyUser(field, items, value, null) || 'email já foi incluido' : true
        ]
      }
    },
    requiredRule: function () {
      return function (label, length = null, vmodel = null) {
        return [
          vmodel
            ? vmodel => !!vmodel || 'O campo "' + label + '" é obrigatório'
            : value => !!value || 'O campo "' + label + '" é obrigatório',
          value => value ? length ? value.length <= length || 'O campo "' +
            label + '" deve conter no máximo ' + length + ' caracteres' : true
            : true
          // length ? value => new RegExp('^.{0,' + length + '}$', 'g').test(value) || 'O campo "' + label + '" deve conter no máximo ' + length + ' caracteres' : true
        ]
      }
    },
    requiredRuleValue: function () {
      return function (label) {
        return [
          value => (!!value) || 'O campo "' + label + '" é obrigatório',
          value => (value != "R$ 0,00") || 'O campo "' + label + '" é obrigatório'
        ]
      }
    },
    requiredFileNameRule: function () {
      return function (label) {
        return [
          value => !!value || 'O campo "' + label + '" é obrigatório',
          value => !value.match(/[*/:?"<>|\\]/g) || 'Caracteres não permitidos: \\ / : * ? " < > |'
        ]
      }
    },
    requiredManyRule: function () {
      return function (label, vmodel = null) {
        return [
          value => (Array.isArray(value) && value.length > 0) || 'O campo "' + label + '" é obrigatório'
        ]
      }
    },
    dateDiffRule: function () {
      return function (required = false, label = 'data', begin = this.editedItem.begin, end = this.editedItem.end, bigger = false) {
        return [
          value => required ? (!!value || 'Os campo ' + label + ' é obrigatório') : true,
          value => begin && end && bigger ? ((parseInt(moment(end).diff(moment(begin))) >= 1) || 'A data fim deve ser maior que a data de início!') : true,
          value => begin && end ? (this.dateCompare(begin, end) || 'A data fim deve ser maior ou igual a data de início!') : true
        ]
      }
    },
    pastDateRule: function () {
      return function (required = false, label = 'data', date = this.editedItem.date) {
        return [
          value => required ? (!!value || 'O campo ' + label + ' é obrigatório') : true,
          value => date ? ((parseInt(moment(date).diff(moment())) >= 1) || 'Não é permitido incluir uma data passada!') : true
        ]
      }
    },
    numericRule: function () {
      return function (label, required = true) {
        return [
          required
            ? value => !!value || 'O campo "' + label + '" é obrigatório'
            : true,
          value => value ? !/\D/.test(value) || 'Apenas números' : true
          // value => /\d+$/.test(value)  || 'Apenas valores numéricos',
        ]
      }
    },
    alphaRule: function () {
      return function (label, required = true) {
        return [
          required
            ? value => !!value || 'O campo "' + label + '" é obrigatório'
            : true,
          value => value ? /^[a-zA-Z\s\u00C0-\u00ff]+$/.test(value) ||
            'Apenas letras' : true
        ]
      }
    },
    normalCharactersRule: function () {
      return function (label, space = true, required = true) {
        return [
          required
            ? value => !!value || 'O campo "' + label + '" é obrigatório'
            : true,
          value => value ? space
            ? /^[a-zA-Z0-9\s\u00C0-\u00ff]+$/.test(value) ||
            'Caracteres especiais não permitidos'
            : /^[a-zA-Z0-9\u00C0-\u00ff]+$/.test(value) ||
            'Caracteres especiais não permitidos' : true
        ]
      }
    },
    numericSpecialRule: function () {
      return function (label, required = true) {
        return [
          required
            ? value => !!value || 'O campo "' + label + '" é obrigatório'
            : true,
          value => value ? !/[a-zA-Z\u00C0-\u00ff]/g.test(value) ||
            'Apenas números' : true
        ]
      }
    },
    phoneRule: function () {
      return function (label, type = 1, required = true) {
        return [
          required
            ? value => !!value || 'O campo "' + label + '" é obrigatório'
            : true,
          value => value ? this.phone(value, type) : true
        ]
      }
    },
    alphabeticRule: function () {
      return function (label, required = true) {
        return [
          required
            ? value => !!value || 'O campo "' + label + '" é obrigatório'
            : true,
          value => value ? /^[a-zA-Z\s\u00C0-\u00ff]+$/.test(value) ||
            'Apenas letras' : true,
          value => value ? !/(?= )/g.test(value) || 'Apenas uma palavra' : true
        ]
      }
    },
    stateRule: function () {
      return function (label, required = true) {
        return [
          required
            ? value => !!value || 'O campo "' + label + '" é obrigatório'
            : true,
          value => value ? /^(?:A[CLPM]|BA|CE|DF|ES|GO|M[ATSG]|P[RBAEI]|R[JNSOR]|S[CEP]|TO)$/.test(value) ||
            'Esse estado não é valido' : true
        ]
      }
    },
    fixedSizeRule: function () {
      return function (label, length, required = true) {
        return [
          required
            ? value => !!value || 'O campo "' + label + '" é obrigatório'
            : true,
          value => value ? length ? value.length === length || 'O campo "' +
            label + '" deve conter ' + length + ' dígitos' : true
            : true
        ]
      }
    }
  }
}

// DOCUMENTATION
// The methods are not the rules itself, they're functions used on them for making more complex rules a possible feature.
// The "exists" method search for repeated registers on the items list and returns a boolean
// Rules are only possible in this implementation on the "computed"
// ----------------------------------------------------------------------------------------------------------------------
// RULES:
// "existRule" Checks if the value is already on the database or not
// "existManyRule" Checks if the value is already on the database or not in a field with multiples items
// "emailRule" Checks if the value is valid e-mail and can also check if there's already the same e-mail included
// "emailManyRule" Checks a ruled field of many emails, verifying if all the emails are valid and verifying if any of those emails are already registered
// "requiredRule" Checks if there's a value
// "requiredFileNameRule" Checks if there's a character not allowed for naming files.
// "numericRule" Checks if contains only numbers, it's also good when comes to select fields because the id it's the value
// "alphaRule" Checks if the value is only letters and spaces
// "alphabeticRule" Checks if the value is only letters
// "numericSpecialRule" Accepts only numbers and special characters
// "normalCharactersRule" Accepts only normal characters and space bar is optional
// "phoneRule" It's a brazilian phone rule, accepting telephones and cellphones
// ----------------------------------------------------------------------------------------------------------------------
// notes: "value" is the v-model of the ruled field



// WEBPACK FOOTER //
// ./src/mixin/rules.js